export default __webpack_public_path__ + "static/media/view-more-arrow.a76ace9f.svg";